import React from 'react';
import { Autocomplete, TextField } from '@mui/material';
import { Controller } from 'react-hook-form';
import { useSelector } from 'react-redux';
import { getUOMOptions } from '../../api/codelist/codeListsSlice';
import { useTranslatedMessages } from '../../hooks/useTranslatedMessages';

const UOMSelect = ({ name, label, control, errors, readOnly = false, disabled }) => {
  const { common } = useTranslatedMessages();
  const uomSelect = common.uom_select ?? {};
  const resolvedLabel = label ?? uomSelect.label;
  const uomOptions = useSelector(getUOMOptions);

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => {
        return (
          <Autocomplete
            {...field}
            id="unit-of-measure-select"
            options={uomOptions}
            readOnly={readOnly}
            getOptionLabel={(option) => `${option.code} - ${option.name}`}
            renderInput={(params) => (
              <TextField
                {...params}
                id="unit-of-measure-select"
                label={resolvedLabel}
                error={!!errors[name]}
                helperText={errors[name]?.message}
              />
            )}
            isOptionEqualToValue={(option, value) => option.code === value?.code}
            onChange={(_, value) => field.onChange(value)}
            value={field.value || null}
            disabled={disabled}
          />
        );
      }}
    />
  );
};

export default UOMSelect;
